import React from 'react'
export const TourAdminPage:React.FC=()=>{
    return(
        <div>
            Tour Admin Page
        </div>
    )
}